<template>
  <div class="pb-3" >
    <va-card :title="$t(`stock.cards.create`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onCreate)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required|numeric|min_value:1" :name="$t('stock.headings.amount').toLowerCase()" v-slot="{ errors }">
                <va-input
                  v-model="amount"
                  type="number"
                  :label="$t('stock.headings.amount')"
                  :placeholder="$t('stock.headings.amount')"
                  :success="errors.length == 0 && amount > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'ProductsStockAdd',
  props: {
    page: {
      type: Number,
      required: true,
    },
    id: {
      required: true,
    },
  },
  data () {
    return {
      amount: 1,
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    onCreate () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const self = this
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($qtd: Int!, $product_id: Int!) {
              insert_stock_one(object: {product_id: $product_id, qtd: $qtd}) {
                id
              }
            }
            `,
          variables: {
            qtd: this.amount,
            product_id: this.id,
          },
        })
        .then(response => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          this.amount = 0
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t('toasts.successCreate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(e => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          this.amount = 0
          self.$emit('showAdd', false)
          self.showToast(
            self.$t('toasts.errorCreate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
</style>
